<section class="table-page modal-detalle-proyeccion">
  <header class="modal-detalle-proyeccion__header">
    <div class="modal-detalle-proyeccion__title-wrap">
      <div class="table-page__copy">
        <h2>Tareas de {{ data.empleado }}</h2>
        <p>{{ data.fecha | date : "fullDate" }}</p>
      </div>
    </div>

    <div class="modal-detalle-proyeccion__header-actions">
      <button type="button" mat-icon-button class="table-page__action-btn" (click)="closeModal()" aria-label="Cerrar detalle">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="modal-detalle-proyeccion__body" mat-dialog-content>
    <ng-container *ngIf="proyectos?.length; else emptyDetalleState">
      <article class="modal-detalle-proyeccion__project-card" *ngFor="let proyecto of proyectos">
        <div class="modal-detalle-proyeccion__project-toolbar">
          <p class="modal-detalle-proyeccion__project-name">
            {{ proyecto.nombre }} · {{ proyecto.nombre_corto || proyecto.nombreCorto || "Sin nombre corto" }}
          </p>
          <button type="button" mat-raised-button class="modal-detalle-proyeccion__add-button" (click)="agregarEditar(null)">
            <mat-icon>add_circle</mat-icon>
            Agregar tarea
          </button>
        </div>

        <div class="modal-detalle-proyeccion__task-list">
          <article class="modal-detalle-proyeccion__task-row" *ngFor="let tarea of proyecto.tareas">
            <div class="modal-detalle-proyeccion__task-primary">
              <strong class="modal-detalle-proyeccion__task-name">{{ tarea.nombre }}</strong>
              <div class="modal-detalle-proyeccion__task-summary">
                <span>
                  {{ tarea.tiempoTarea?.length || 0 }}
                  {{ (tarea.tiempoTarea?.length || 0) === 1 ? "bloque" : "bloques" }}
                </span>
                <span aria-hidden="true">·</span>
                <span *ngIf="tarea.evidencias?.length; else sinEvidenciasResumen">
                  {{ tarea.evidencias.length }}
                  {{ tarea.evidencias.length === 1 ? "evidencia" : "evidencias" }}
                </span>
                <ng-template #sinEvidenciasResumen>Sin evidencias</ng-template>
              </div>
              <div *ngIf="tarea.evidencias?.length" class="modal-detalle-proyeccion__evidence-actions">
                <ng-container *ngFor="let evidencia of tarea.evidencias">
                  <button
                    type="button"
                    class="table-page__action-btn"
                    (click)="consultaImagenEvidencia(proyecto.id, evidencia)"
                    [attr.aria-label]="'Ver evidencia ' + evidencia.nombreArchivo"
                  >
                    <i class="material-icons">visibility</i>
                  </button>
                  <button
                    type="button"
                    class="table-page__action-btn"
                    (click)="descargaEvidencia(proyecto.id, evidencia)"
                    [attr.aria-label]="'Descargar evidencia ' + evidencia.nombreArchivo"
                  >
                    <i class="material-icons">cloud_download</i>
                  </button>
                </ng-container>
              </div>
            </div>

            <div class="modal-detalle-proyeccion__status-cell">
              <mat-chip
                [ngClass]="{
                  'estatus-creado': tarea.estatus === 'CREADO',
                  'estatus-activo': tarea.estatus === 'ACTIVO',
                  'estatus-pausado': tarea.estatus === 'PAUSADO',
                  'estatus-terminado': tarea.estatus === 'TERMINADO'
                }"
              >
                {{ tarea.estatus }}
              </mat-chip>
            </div>

            <div class="modal-detalle-proyeccion__time-summary">
              <div>
                <span>Inicio</span>
                <strong>{{ tarea.fecha_inicio | date : "HH:mm" }}</strong>
              </div>
              <div>
                <span>Fin</span>
                <strong>{{ tarea.fecha_fin | date : "HH:mm" }}</strong>
              </div>
              <div>
                <span>Total</span>
                <strong>{{ tarea.tiempoTotalInvertidoStr || "00:00:00" }}</strong>
              </div>
            </div>

            <div class="modal-detalle-proyeccion__task-action">
              <button type="button" class="table-page__action-btn" (click)="agregarEditar(tarea, proyecto.nombre)" aria-label="Editar tarea">
                <i class="material-icons">edit</i>
              </button>
            </div>
          </article>
        </div>
      </article>
    </ng-container>
  </div>

  <ng-template #emptyDetalleState>
    <div class="table-page__empty modal-detalle-proyeccion__empty">
      <i class="material-icons">playlist_remove</i>
      <strong>Sin tareas registradas</strong>
      <span>No se encontraron tareas para el día seleccionado.</span>
    </div>
  </ng-template>

  <a class="modal-detalle-proyeccion__download-link" #downloadFile aria-label="Descargar archivo"></a>
</section>
